import { PRODUCT_NAME_FULL } from "../../product-name";

/**
 * What the product calls itself (#782) — re-exported from `web/product-name.ts`, the same file
 * the operator console reads, so the name is one value across both surfaces rather than two that
 * drift. Sections import it from here; nothing on this page spells the name.
 */
export { PRODUCT_NAME, PRODUCT_SUFFIX, PRODUCT_NAME_FULL } from "../../product-name";

// Contact target for the demo CTA. The design ships demoEmail=demo@example.com as its
// default prop; swap this constant for the real address once the owner decides (#186).
export const DEMO_EMAIL = "demo@example.com";

export const DEMO_MAILTO = `mailto:${DEMO_EMAIL}?subject=${encodeURIComponent(
  `Demo-Anfrage ${PRODUCT_NAME_FULL}`,
)}`;
